import { memo, useCallback, useEffect, useState, FC } from 'react';
import { createPortal } from 'react-dom';

import { apiGetLivestreamBannerInfo } from 'src/api/livestream';
import { apiDismissLivestreamBanner } from 'src/api/сampaignUserPreferences';
import { IconCircleBell } from 'src/components/Icons/CircleBell';
import { IconClocks } from 'src/components/Icons/Clocks';
import { IconCross } from 'src/components/Icons/Cross';
import { UiButton } from 'src/components/UI/Button';
import { UiInnerNotSPALink } from 'src/components/UI/InnerNotSPALink';
import { DOM_ELEMENT_FOR_PORTALS } from 'src/config';
import { showAnyErrors } from 'src/utils/errors';
import { useTHelper } from 'src/utils/i18n';

type Props = {
  permanentUrl: string;
};

export const LivestreamApproachingBanner: FC<Props> = memo(({ permanentUrl }) => {
  const tHelper = useTHelper('header.livestreamBanner');

  const bemHelper = useCallback((str?: string): string => `livestream-remind-start-banner${str || ''}`, []);

  const [show, setShow] = useState(false);
  const [dateStr, setDateStr] = useState('');

  const onDismiss = useCallback(() => {
    apiDismissLivestreamBanner({ CampaignPermanentUrl: permanentUrl })
      .then(() => {
        setShow(false);
      })
      .catch(showAnyErrors);
  }, [permanentUrl]);

  useEffect(() => {
    if (permanentUrl) {
      apiGetLivestreamBannerInfo({ campaignUrl: permanentUrl }).then(
        ({ LivestreamBannerIsVisible, LivestreamDateInfo }) => {
          if (LivestreamBannerIsVisible) {
            setDateStr(LivestreamDateInfo);

            setShow(LivestreamBannerIsVisible);
          }
        }
      );
    }
  }, [permanentUrl, tHelper]);

  return show
    ? createPortal(
        <div className={bemHelper()}>
          <div className={bemHelper('-header')}>
            <div role="presentation" className={bemHelper('-close')} onClick={onDismiss}>
              <IconCross />
            </div>
          </div>
          <div className={bemHelper('-body')}>
            <div className={bemHelper('-title-container')}>
              <IconCircleBell />

              <div className={bemHelper('-title')}>{tHelper('title')}</div>
            </div>
            <div className={bemHelper('-description')}>{tHelper('description')}</div>
            <div className={bemHelper('-datetime')}>
              <IconClocks />
              {dateStr}
            </div>
          </div>
          <div className={bemHelper('-button-container')}>
            <UiButton tag="a" className="LinkTextColor" onClick={onDismiss}>
              {tHelper('cancelBtn')}
            </UiButton>
            <UiInnerNotSPALink
              className="btn-primary btn fw-400"
              href={`/Account/Organizer/LiveStream/StreamManager/${permanentUrl}`}
            >
              {tHelper('goToStreamBtn')}
            </UiInnerNotSPALink>
          </div>
        </div>,
        DOM_ELEMENT_FOR_PORTALS
      )
    : null;
});
